import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Timeformat from "../../utils/Timeformat";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import StaticFunctions from "../../utils/StaticFunctions";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import {confirmAlert} from "react-confirm-alert";

class UserOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        currentCompany: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.currentCompany,
            currentCompanyUsers: null,
            filteredCompanyUsers: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.requestCompanyUsers = this.requestCompanyUsers.bind(this);
        this.deleteUser = this.deleteUser.bind(this);

    }

    componentWillMount() {

        this.requestCompanyUsers();

    }

    requestCompanyUsers() {

        const params = {
            action: 'getCompanyUsers',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyUsers: res,
                    filteredCompanyUsers: this.getTableData(res),
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    onSearch(name, value) {

        const tableData = this.getTableData(this.state.currentCompanyUsers);
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredCompanyUsers: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyUsers: this.getTableData(this.state.currentCompanyUsers),
        });

    }

    editUser(user) {

        this.changeView('edit', user);

    }

    locationDelete(location) {

        const params = {
            action: 'deleteCompanyLocation',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            id: parseInt(location.id),
            companyId: parseInt(location.id_company),
            name: location.name,
            machineCount: parseInt(location.machine_count),
        };

        if (params.machineCount !== 0) {
            alert(this.translate('locationStillContainsMachines'));
        } else {
            confirmAlert({
                title: this.translate('deleteLocation'),
                message: this.translate('deleteLocationQuestion') + ' "' + params.name + '" ',
                buttons: [
                    {
                        label: this.translate('yes'),
                        onClick: () => {
                            const callback = function (res) {
                                if (res.success) {
                                    alert(this.translate(res.msgKey));

                                    this.requestCompanyLocations();
                                }
                            }.bind(this);

                            this.api.request('AdminFunctions', params, callback);
                        }
                    },
                    {
                        label: this.translate('no'),
                    }
                ]
            });
        }

    }

    deleteUser(user) {

        if (user && user.date_deleted === null) {
            const params = {
                action: 'deletedCompanyUser',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: this.props.currentCompany.id,
                userId: this.props.baseData.userData.id,
                deleteId: user.id
            };

            confirmAlert({
                title: this.translate('deleteUser'),
                message: this.translate('deleteUserQuestion') + ' "' + user.email + '" ',
                buttons: [
                    {
                        label: this.translate('yes'),
                        onClick: () => {
                            const callback = function(res) {
                                this.requestCompanyUsers();
                            }.bind(this);

                            this.api.request('AdminFunctions', params, callback);
                        }
                    },
                    {
                        label: this.translate('no'),
                    }
                ]
            });
        }

    }

    changeView(view, user = null) {

        if (this.props.changeView) this.props.changeView(view, user);

    }

    getTableData(rawData) {

        rawData = (rawData) ? rawData : this.state.currentCompanyUsers;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const rows = [];

        for (let i = 0; i < rawData.length; i++) {
            let rowTemp = rawData[i];
            let lastSeen = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
            let validUntil = (rowTemp.valid_until) ? Timeformat.fromUnix(rowTemp.valid_until).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
            let dateDeleted = (rowTemp.date_deleted) ? Timeformat.fromUnix(rowTemp.date_deleted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                id: rowTemp.id,
                email: rowTemp.email,
                first_name: rowTemp.first_name,
                last_name: rowTemp.last_name,
                last_seen: rowTemp.last_seen,
                formatedLastSeen: lastSeen,
                valid_until: rowTemp.valid_until,
                formatedValidUntil: validUntil,
                date_deleted: rowTemp.date_deleted,
                formatedDateDeleted: dateDeleted
            });
        }

        return rows;

    }

    getCompanyUserColumns() {

        const columns = [];

        if (this.props.baseData.checkUserRole('superadmin')) {
            columns.push({
                key: 'id',
                name: this.translate('id'),
                sortType: 'int',
            });
        }

        columns.push(
            {
                key: 'email',
                nameKey: 'email',
                sortType: 'string',
            },
            {
                key: 'firstName',
                nameKey: 'firstName',
                sortType: 'string',
            },
            {
                key: 'lastName',
                nameKey: 'lastName',
                sortType: 'string',
            },
            {
                key: 'lastSeen',
                nameKey: 'lastSeen',
                sortType: 'datetime',
            },
            {
                key: 'validUntil',
                nameKey: 'validUntil',
                sortType: 'datetime',
            },
            {
                key: 'dateDeleted',
                nameKey: 'deletedOn',
                sortType: 'datetime',
            },
            {
                key: 'options',
                name: this.translate('options'),
            }
        );

        return columns;

    }

    getCompanyUserRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = (this.state.filteredCompanyUsers) ? this.state.filteredCompanyUsers : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let deleteButton = (rowTemp.date_deleted === null) ? <a className="optionDelete" onClick={() => this.deleteUser(rowTemp)} title={this.translate('delete')}>&nbsp;</a> : '';

            rows.push({
                id: rowTemp.id,
                email: rowTemp.email,
                firstName: rowTemp.first_name,
                lastName: rowTemp.last_name,
                lastSeen: rowTemp.formatedLastSeen,
                validUntil: rowTemp.formatedValidUntil,
                dateDeleted: rowTemp.formatedDateDeleted,
                options: <div className="tableOptions">
                    <a className="optionEdit" onClick={() => this.editUser(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                    {deleteButton}
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (!this.state.currentCompanyUsers) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredCompanyUsers) ? this.state.filteredCompanyUsers.length : 0;
        const countText = this.translate('user');
        const userColumns = this.getCompanyUserColumns();
        const userRows = this.getCompanyUserRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectUser')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchUserOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>

                        <div className="flr">
                            <div className="bottomLinks">
                                <a className="prewLink" onClick={(e) => this.changeView('add')}>{this.translate('addNewUser')}</a>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={userColumns}
                            rows={userRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default UserOverviewContainer;
